import { useMemo } from 'react';
import { qrcodegen } from '../vendor/qrcodegen';

/** QR-code als SVG (zonder extra bibliotheek of netwerk): zwart op wit, met een rustige rand. */
export function QrCode({ text, size = 220, label }: { text: string; size?: number; label: string }) {
  const path = useMemo(() => {
    const qr = qrcodegen.QrCode.encodeText(text, qrcodegen.QrCode.Ecc.MEDIUM);
    const parts: string[] = [];
    for (let y = 0; y < qr.size; y++) for (let x = 0; x < qr.size; x++) if (qr.getModule(x, y)) parts.push(`M${x + 4},${y + 4}h1v1h-1z`);
    return { d: parts.join(''), n: qr.size + 8 };
  }, [text]);
  return (
    <svg className="qr-code" width={size} height={size} viewBox={`0 0 ${path.n} ${path.n}`} role="img" aria-label={label} shapeRendering="crispEdges">
      <rect width={path.n} height={path.n} fill="#fff" />
      <path d={path.d} fill="#000" />
    </svg>
  );
}
